var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbierta(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E8F0ACBE-A84C-49F8-BBE0-C670F56BE45D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Udala-Zabaltzen-0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kalezaindu_incidencia_detalle_desktop",
    transform: "translate(-702.000000, -656.000000)",
    fill: "#1C3561"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M710.71821,677.912627 C704.90607,673.94689 702,669.656742 702,665.042185 C702,660.048324 706.029437,656 711,656 C715.970563,656 720,660.048324 720,665.042185 C720,669.656723 717.093955,673.946853 711.281864,677.912576 L711.281899,677.912626 C711.111903,678.028618 710.888205,678.028618 710.71821,677.912627 Z M711,668.056247 C712.656854,668.056247 714,666.706805 714,665.042185 C714,663.377565 712.656854,662.028123 711,662.028123 C709.343146,662.028123 708,663.377565 708,665.042185 C708,666.706805 709.343146,668.056247 711,668.056247 Z",
    id: "Mask"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbierta);
export default __webpack_public_path__ + "static/media/Abierta.7dc9ee554d7c00c8b128cb53bcf27a09.svg";
export { ForwardRef as ReactComponent };